/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const BASE = "/agreements";
export const BASE_AGREEMENT = "/agreement";

export const AGREEMENTS_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Sales Agreements",
} as const;

export const AGREEMENT_DETAIL_ROUTE = `${BASE_AGREEMENT}/:salesAgreementId`;
export const AGREEMENT_DRAWDOWN_ROUTE = `${BASE_AGREEMENT}/:salesAgreementId/drawdown`;
export const AGREEMENT_CAMPAIGN_SUCCESS_ROUTE = `${BASE}/campaign-success`;
